__webpack_require__.p = "https://images-cdn-staging.curipod.com/d-c671718c/_next/";